import * as React from 'react';
import { StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Stepper } from '@material-ui/core';
import { Step } from '@material-ui/core';
import { StepLabel } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import { BaseModule } from '../../../pages/questionModuleTypes';
import { translation } from '../../../i18n';
import { observer } from 'mobx-react';
import { Typography } from '@material-ui/core';

interface Props {
  modules: BaseModule[],
  renderModule: (activeStep: number) => JSX.Element,
  finishPage: {
    head: string,
    body: string,
  },
}

interface State {
  activeStep: number,
}

type LocalStyles = 'root' | 'buttonSection' | 'button' | 'finishPage';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing.unit * 2
  },
  buttonSection: {
    marginTop: theme.spacing.unit,
    textAlign: 'right',
  },
  button: {
    marginLeft: theme.spacing.unit,
  },
  finishPage: {
    margin: theme.spacing.unit * 2,
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class Catalogue extends React.Component<PropsWithStyle, State> {
  public state = {
    'activeStep': 0,
  };

  constructor(props: PropsWithStyle) {
    super(props)
  }

  public render() {
    const {classes} = this.props;
    return (
      <Paper elevation={1} className={classes.root}>
        <div>
          <Stepper activeStep={this.state.activeStep} alternativeLabel={true}>
            {this.props.modules.map(module => {
              return (
                <Step key={module.id}>
                  <StepLabel>{module.title}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </div>
        {this.renderButtons()}
        {
          this.state.activeStep < this.props.modules.length ?
            (this.props.renderModule(this.state.activeStep)
            ) :
            (this.renderFinishPage())
        }
        {
          this.state.activeStep < this.props.modules.length &&
          this.renderButtons()
        }
      </Paper>
    )
  }

  private renderFinishPage() {
    return (
      <div className={this.props.classes.finishPage}>
        <Typography variant="h5">
          {this.props.finishPage.head}
        </Typography>
        <br/>
        <Typography variant="body1">
          {this.props.finishPage.body}
        </Typography>
      </div>
    )
  }

  private handleBack = () => {
    window.scrollTo(0, 0);
    this.setState({
      activeStep: this.state.activeStep - 1,
    });
  };

  private handleNext = () => {
    window.scrollTo(0, 0);
    this.setState({
      activeStep: this.state.activeStep + 1,
    });
  };

  private renderButtons() {
    return (
      <div className={this.props.classes.buttonSection}>
        <Button
          variant="contained"
          color="primary"
          disabled={this.state.activeStep === 0}
          onClick={this.handleBack}
          className={this.props.classes.button}
        >
          {translation.t('actions.back')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={this.handleNext}
          className={this.props.classes.button}
          disabled={this.state.activeStep === this.props.modules.length}
        >
          {
            this.state.activeStep < this.props.modules.length - 1 ?
              (translation.t('actions.next')) :
              (translation.t('actions.finish'))
          }
        </Button>
      </div>
    )
  }
}

export default withStyles(localStyles)(Catalogue);

